import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueGtag from 'vue-gtag'
import jQuery from 'jquery'
import vueResource from 'vue-resource'
import commonServices from 'Common/services'
global.jQuery = jQuery
global.$ = jQuery

import Transitions from 'vue2-transitions'
Vue.config.productionTip = false
Vue.use(Transitions)
Vue.use(vueResource)
Vue.use(commonServices)

Vue.use(VueGtag, {
	config: { id: "UA-65426508-2" },
	appName: 'Glarus www',
  	pageTrackerScreenviewEnabled: true
}, router)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
